export const STATUSES = {
    UNASSIGNED: 3,
    ASSIGNED: 4,
    ENROUTE: 5,
    ONSITE: 6,
    COMPLETE: 7,
    BELL_BILLING_APPROVAL: 8,
    BILLING_APPROVED: 9,
    PENDING_REVIEW: 10,
    BILLING_ADJUSTMENT: 11,
    CLOSED: 12,
    RAP_REQUESTED: 13,
    CLOSED_INCOMPLETE: 14,
    CANCELLED: 15,
    INCOMPLETE: 16,
    PENDING_PO: 17, // We do not use this and 18; we replace them with BILLING_APPROVED later
    ERROR_PO_CREATION: 18,
};

export const FOLLOW_UP = {
    CREATE_FOLLOW_UP: 1,
};

export const INCOMPLETE_REASON_CODES = {
    NO_WORK_TO_DO: 1,
    CUSTOMER_REQUESTED_DIFF_DAY: 2,
    CUSTOMER_REFUSED_WORK: 3,
    OTHER_CONSTRUCTION: 4,
    HYDRO_VAC_REQUIRED: 5,
    NO_ACCESS_TO_SITE: 6,
    CALLED_TO_EMERGENCY: 7,
    LOCATES_INCORRECT: 8,
    INCORRECT_LOI_INFO: 9,
    TECH_REQUIRED_ON_SITE: 10,
    WORK_SITE_UNSAFE: 11,
    NETWORK_ISSUES: 12,
    BLOCKED_CONDUIT: 13,
    CUSTOMER_NEIGHBOUR_REFUSED_ACCESS: 14,
};

export const isRequiredSentToBell = (status = {}) => status && [STATUSES.PENDING_REVIEW, STATUSES.BILLING_ADJUSTMENT].includes(status.id);
export const isActionsRequired = (status = {}) =>
    [STATUSES.ASSIGNED, STATUSES.ENROUTE, STATUSES.ONSITE, STATUSES.INCOMPLETE, STATUSES.COMPLETE].includes(status.id);
export const isMarkedAsIncomplete = (status = {}) => [STATUSES.CLOSED_INCOMPLETE, STATUSES.INCOMPLETE].includes(status.id);
export const isCancelled = (status = {}) => [STATUSES.CANCELLED].includes(status.id);
export const areAttachmentsEnabled = (status = {}) =>
    [
        STATUSES.BILLING_ADJUSTMENT,
        STATUSES.UNASSIGNED,
        STATUSES.ASSIGNED,
        STATUSES.ENROUTE,
        STATUSES.ONSITE,
        STATUSES.PENDING_REVIEW,
        STATUSES.RAP_REQUESTED,
        STATUSES.INCOMPLETE,
    ].includes(status.id);
export const labourerItemsAreEnabled = (status = {}) => [STATUSES.ASSIGNED, STATUSES.ENROUTE, STATUSES.ONSITE].includes(status.id);
export const isActionRequired = (status = {}) => [STATUSES.UNASSIGNED].includes(status.id);

export const WORKORDER_STATUS_MAP = {
    enroute: {
        id: STATUSES.ENROUTE,
        name_en: "En Route",
        name_fr: "En route",
    },
    onsite: {
        id: STATUSES.ONSITE,
        name_en: "On Site",
        name_fr: "Sur site",
    },
};
